import React from "react";
import WhatsAppIcon from "@mui/icons-material/WhatsApp";
import styles from "./WhatsAppAnnouncementCard.module.css";

interface WhatsAppAnnouncementCardProps {
  className?: string;
}

const WhatsAppAnnouncementCard: React.FC<WhatsAppAnnouncementCardProps> = ({
  className,
}) => {
  const handleWhatsAppClick = () => {
    const phoneNumber = "+59172233666";
    const message = "Hola! Me interesa conocer más sobre sus productos.";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(whatsappUrl, "_blank");
  };

  return (
    <div className={`${styles.whatsappContainer} ${className || ""}`}>
      <div className={styles.whatsappContent}>
        <WhatsAppIcon className={styles.whatsappIcon} />
        <div className={styles.whatsappText}>
          <h3>¿No encuentras lo que buscas?</h3>
          <p>
            Escríbenos por WhatsApp y te ayudamos a encontrar el producto
            perfecto
          </p>
        </div>
      </div>
      <button
        onClick={handleWhatsAppClick}
        className={styles.whatsappButton}
        aria-label="Escríbenos por WhatsApp"
      >
        Escríbenos por WhatsApp
      </button>
    </div>
  );
};

export default WhatsAppAnnouncementCard;
